import { useState, useEffect, useRef } from "react";
import "./style3.scss";

import "react-multi-date-picker/styles/layouts/prime.css";
import styles from "../bussiness.module.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import Select from "react-select";
import axios from "axios";
import { HiOutlineSave } from "react-icons/hi";
import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import ReactTooltip from "react-tooltip";
// import { connection } from "utils/apiConnection.ts";
import toast from "react-hot-toast";
// import TodoList from "../RezervTodos/TodoList/TodoList";
import TodoApp from "./rezervToDo/TodoApp.js";

import useAxios from "../../../services/useAxios.tsx";

function AddProduct({ setUpdater, updater, setIsLoading }) {
  const { execute: productData } = useAxios(
    "superadminapi/get_add_edit_product_data"
  );
  const { execute: getSuppliers } = useAxios("superadminapi/getsuppliers");
  const { execute: addProduct } = useAxios("superadminapi/addproduct");
  const [todos, setTodos] = useState([]);
  const [allProductTags, setAllProductTags] = useState([
    { value: "55", label: "jj" },
  ]);
  const [allLeader, setAllLeader] = useState([]);
  const [filterCat, setFilterCat] = useState();
  const [filterLine, setFilterLine] = useState();
  const [allUserTag, setAllUserTag] = useState([
    { label: "", value: "", id: 0, default_price: 0, default_need_time: 0 },
  ]);
  const [option, setOption] = useState([
    { id: "", title: "", default_need_time: "", default_price: "" },
  ]);
  const [otherInfo, setOtherInfo] = useState({
    title: "",
    default_price: "",
    default_weight_from: "",
    default_weight_to: "",
    cat_id: "-1",
    line_id: [],
    sub_line_id: [],
    main_cover_file_id: "",
    best_supplier_id: "",
  });
  const [disabledBtn, setDisabledBtn] = useState(false);
  const inputElement = useRef();

  function postHandler() {
    // let line = otherInfo.line_id.map((value) => value.value)
    // .join(",");
    // let lineSub = otherInfo.sub_line_id.map((value) => value.value)
    // .join(",");

    setIsLoading(true);
    const todoData = todos.map((val) => {
      if (val.user_tag_id.value == val.user_tag_id.label) {
        return {
          id: -1,
          text: val.text,
          price: val.price,
          user_tag_id: val.user_tag_id.label,
        };
      } else {
        return {
          id: val.user_tag_id.value,
          text: val.text,
          price: val.price,
          user_tag_id: val.user_tag_id.label,
        };
      }
    });
    let myFormData = new FormData();
    let coverx = otherInfo.sub_line_id.value;
    if (otherInfo.sub_line_id.value === undefined) coverx = "";
    myFormData.append("title", otherInfo.title);
    myFormData.append("default_price", otherInfo.default_price);
    myFormData.append("default_weight_from", otherInfo.default_weight_from);
    myFormData.append("default_weight_to", otherInfo.default_weight_to);
    myFormData.append("cat_id", otherInfo.cat_id);
    myFormData.append("main_cover_file_id", otherInfo.main_cover_file_id);
    myFormData.append("line_id", otherInfo.line_id.value);
    myFormData.append("sub_line_id", coverx);
    for (let index2 = 0; index2 < todoData.length; index2++) {
      myFormData.append(`title_${[index2]}`, todoData[index2].user_tag_id);
      myFormData.append(
        `default_need_time_${[index2]}`,
        todoData[index2].text != undefined ? todoData[index2].text * 60 : "0"
      );
      myFormData.append(
        `default_price_${[index2]}`,
        todoData[index2].price != undefined ? todoData[index2].price : "0"
      );
      myFormData.append(`id_${[index2]}`, todoData[index2].id);
      myFormData.append(`option_count`, todoData.length);
    }
    myFormData.append(
      "best_supplier_id",
      otherInfo.best_supplier_id.value ? otherInfo.best_supplier_id.value : 0
    );
    const getInfo = async () => {
      if (otherInfo.title.trim() == "" || otherInfo.cat_id === "-1") {
        toast.error("نام و دسته بندی را وارد نمایید");
        return null;
      }
      if (otherInfo.line_id.length == 0) {
        toast.error("لاین را وارد نمایید");
        return null;
      }
      setDisabledBtn(true);
      // let data = await
      //  axios
      //   .post("https://sabadi.ir/api/superadminapi/addproduct", myFormData)
      addProduct(myFormData).then((data) => {
        if (data.status == 1) {
          setDisabledBtn(false);
          toast.success("  محصول با موفقیت اضافه شد");

          setOtherInfo({
            title: "",
            default_price: "",
            default_weight_from: "",
            default_weight_to: "",
            cat_id: "-1",
            line_id: [],
            sub_line_id: [],
            main_cover_file_id: [],
            best_supplier_id: "",
          });
          setimg("");
          inputElement.current.click();
          setUpdater(!updater);
          setIsLoading(false);
        } else {
          setDisabledBtn(false);
          toast.error(
            ", عنوان و دسته بندی ضروری است خطا در اضافه کردن کسب و کار!"
          );
          setIsLoading(false);
        }
      });
    };
    getInfo();
  }
  const handleChangeOption = (index, event) => {
    const values = [...option];
    values[index][event.target.name] = event.target.value;
    option(values);
  };
  const changeHandleraSubLines = (option) => {
    setOtherInfo((prev) => {
      let temp = { ...prev };
      temp.sub_line_id = option;
      return { ...temp };
    });
  };
  const changeHandleraTags = (option) => {
    let temp = {};
    setOtherInfo((prev) => {
      temp = { ...prev };
      temp.line_id = option;
      return { ...temp };
    });
    setFilterLine(temp.line_id);
  };
  function handleChange(event) {
    let value = removeCommas(event.target.value);
    if (!isNaN(value)) {
      setOtherInfo({
        ...otherInfo,
        [event.target.name]: value,
      });
    }
  }
  function inputChangeHandler(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  }
  function inputChangeHandlerDaste(event) {
    setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
    setFilterCat(event.target.value);
  }

  const test = allProductTags.filter((item) => {
    if (item.main_cat == filterCat && item.parent_line_id == 0) {
      return item;
    }
  });

  const essen = () => {
    let x = filterLine;
    if (x != undefined) {
      return x.value;
    } else {
      return console.log("errEss");
    }
  };

  const subLine = allProductTags.filter((item) => {
    if (item.parent_line_id == essen()) {
      return item;
    }
  });

  const changeHandlerImg = (e) => {
    setOtherInfo({ ...otherInfo, [e.target.name]: e.target.files[0].name });
  };
  const inputRef = useRef();
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data", {});
      let data = await productData();

      var allUserTagTemp = [];
      for (let index = 0; index < data.avb_options.length; index++) {
        let newObject = {};
        newObject.value = data.avb_options[index].id;
        newObject.label = data.avb_options[index].title;
        newObject.default_need_time = data.avb_options[index].default_need_time;
        newObject.default_price = data.avb_options[index].default_price;
        allUserTagTemp.push(newObject);
      }
      setAllUserTag(allUserTagTemp);
    }
    loadPage();
  }, []);
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data", {});
      let data = await productData();
      let allProductTags = [];
      for (let index = 0; index < data.lines.length; index++) {
        let newObject = {};
        newObject.value = data.lines[index].id;
        newObject.label = data.lines[index].title;
        newObject.main_cat = data.lines[index].main_cat;
        newObject.parent_line_id = data.lines[index].parent_line_id;
        allProductTags.push(newObject);
      }
      setAllProductTags(allProductTags);
      // console.log("all product tags : ", allProductTags);
    }
    loadPage();
  }, []);
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/get_add_edit_product_data", {} );
      let data = await productData();

      let allLeader = [];
      for (let index = 0; index < data.cats.length; index++) {
        let newObject = {};
        newObject = data.cats[index];

        allLeader.push(newObject);
      }
      setAllLeader(allLeader);
    }
    loadPage();
  }, []);
  const [bestSupplier, setBestSupplier] = useState([]);
  useEffect(() => {
    async function loadPage() {
      // let data = await connection("superadminapi/getsuppliers", {});
      let data = await getSuppliers();
      let allSuppliers = [];
      for (let i = 0; i < data.data.length; i++) {
        let newObject = {};
        newObject.value = data.data[i].info.suppliers__id;
        newObject.label = data.data[i].info.title;
        allSuppliers.push(newObject);
      }
      setBestSupplier(allSuppliers);
    }
    loadPage();
  }, []);
  const [img, setimg] = useState("");
  return (
    <>
      <div
        class="modal fade"
        id={`exampleModalAddProduct`}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        dir="rtl"
        style={{ backgroundColor: "rgba(1,1,1,0.5)" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content ">
            <div className="modal-header" style={{ justifyContent: "end" }}>
              <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
                افزودن محصول
              </h5>
              <button
                type="button"
                className="btn btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body style-container"
              style={{ background: "#e7f1ff" }}
            >
              <div className="edit-user-container">
                <form id="edit-user-form-data" className=" edit-container">
                  <div
                    className="edit-user-item mb-3 d-flex justify-content-center w-100"
                    style={{ marginTop: "-35px" }}
                  >
                    <label htmlFor="profile-pic">
                      <div className="profile-pic position-relative">
                        <input
                          className="d-none"
                          type="file"
                          accept="image/*"
                          id="AddProfilePic"
                          ref={inputRef}
                          // name="main_cover_file_id"
                          // onChange={changeHandlerImg}

                          onChange={(e) => {
                            setimg(URL.createObjectURL(e.target.files[0]));
                            setOtherInfo({
                              ...otherInfo,
                              ["main_cover_file_id"]: e.target.files[0],
                            });
                          }}
                        />

                        {otherInfo.main_cover_file_id == "" ? (
                          <FcPicture
                            style={{
                              width: "80px",
                              // borderRadius: "50%",
                              height: "80px",
                              overflow: "hidden",
                            }}
                          />
                        ) : (
                          <img
                            src={
                              img == ""
                                ? `${
                                    "https://sabadi.ir/api/" +
                                    otherInfo.main_cover_file_id
                                  }`
                                : `${img}`
                            }
                            // src={"https://sabadi.ir/api" + otherInfo.main_cover_file_id}
                            alt=""
                            style={{
                              width: "80px",
                              borderRadius: "50%",
                              height: "80px",
                              overflow: "hidden",
                            }}
                          />
                        )}

                        <label
                          htmlFor="AddProfilePic"
                          className="position-absolute containBoxdark"
                          style={{
                            right: "8px",
                            top: "0px",
                            cursor: "pointer",
                          }}
                        >
                          <FaPlusCircle />
                        </label>
                      </div>
                    </label>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color">عنوان</label>
                      <input
                        className={styles.inputSty}
                        type="text"
                        name="title"
                        value={otherInfo.title}
                        onChange={inputChangeHandler}
                      />
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color">قیمت واحد (تومان) </label>
                      <input
                        min="0"
                        style={{ direction: "rtl" }}
                        className={styles.inputSty}
                        name="default_price"
                        value={addCommas(otherInfo.default_price)}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color">وزن از (گرم) </label>
                      <input
                        className={styles.inputSty}
                        style={{ direction: "rtl" }}
                        name="default_weight_from"
                        value={addCommas(otherInfo.default_weight_from)}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color"> وزن تا (گرم) </label>
                      <input
                        style={{ direction: "rtl" }}
                        className={styles.inputSty}
                        name="default_weight_to"
                        value={addCommas(otherInfo.default_weight_to)}
                        onChange={handleChange}
                        placeholder=" وزن تا (گرم)"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color"> دسته بندی</label>
                      <select
                        name="cat_id"
                        class="form-select form-select-sm"
                        aria-label=".form-select-sm example"
                        style={{
                          direction: "rtl",
                          color: "rgb(100, 100, 100)",
                        }}
                        className={styles.inputSty}
                        value={otherInfo.cat_id}
                        onChange={inputChangeHandlerDaste}
                      >
                        <option selected hidden value="-1" disabled>
                          انتخاب کنید{" "}
                        </option>
                        {allLeader?.map((value, index) => (
                          <option key={index} value={index}>
                            {value}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="widyhBox">
                      <label className="m-1 color"> لاین </label>
                      <Select
                        className=" inputSty "
                        options={test}
                        placeholder={
                          test.length > 0 ? (
                            <div> لطفا لاین را انتخاب کنید</div>
                          ) : (
                            <div> لطفا اول دسته بندی را انتخاب کنید</div>
                          )
                        }
                        value={otherInfo.line_id}
                        onChange={changeHandleraTags}
                        // options={tagsOptions}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                        // value={defaultTags}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between containBox">
                    <div className="widyhBox">
                      <label className="m-1 color"> ساب لاین </label>
                      <Select
                        className=" inputSty "
                        options={subLine}
                        placeholder={
                          subLine.length > 0 ? (
                            <div> لطفا ساب لاین را انتخاب کنید</div>
                          ) : (
                            <div> لطفا اول لاین را انتخاب کنید</div>
                          )
                        }
                        value={otherInfo.sub_line_id}
                        onChange={changeHandleraSubLines}
                        // options={tagsOptions}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                        // value={defaultTags}
                      />
                    </div>
                    {/* انتخاب بهترین فروشگاه */}
                    <div className="widyhBox">
                      <label className="m-1 color">
                        {" "}
                        انتخاب بهترین فروشگاه{" "}
                      </label>
                      <Select
                        className=" inputSty "
                        options={bestSupplier}
                        placeholder={<div> انتخاب کنید</div>}
                        value={otherInfo.best_supplier_id}
                        onChange={(e) => {
                          setOtherInfo((prev) => {
                            return { ...prev, best_supplier_id: e };
                          });
                          console.log("other info. best", otherInfo);
                        }}
                        isMulti={false}
                        style={{ background: "#ddd" }}
                      />
                    </div>
                  </div>
                  <div
                    class="accordion-item mt-3"
                    style={{ borderRadius: "12px" }}
                  >
                    <h2 class="accordion-header" id="flush-headingTwo">
                      <button
                        style={{
                          borderRadius: "12px",
                          borderTop: "1px solid #ddd",
                        }}
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        آپشن جدید
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div class="accordion-body">
                        {" "}
                        <TodoApp
                          todos={todos}
                          setTodos={setTodos}
                          allUserTag={allUserTag}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={inputElement}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  postHandler(otherInfo);
                }}
                disabled={disabledBtn}
              >
                ذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddProduct;
{
}
